/**
 * Cart-Roadmap: "Gratis-Geschenk freigeschaltet"-Banner.
 * Fuegt die Gratis-Buerste mit der Upsell-Shark Gift-Property zum Warenkorb hinzu.
 * Delegierter Listener auf document, damit er Re-Renders des Cart-Drawers ueberlebt.
 */
(function () {
  function addGiftBrush(button) {
    if (button.classList.contains('loading')) return;

    var variantId = button.dataset.giftVariant;
    if (!variantId) return;

    var giftProperty = window.theme && theme.settings && theme.settings.shark_offer_property_gift;

    button.classList.add('loading');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (giftProperty) {
      formData.append('properties[_shark_offer]', giftProperty);
    }

    // bundle_shark=true: Upsell-Shark-Interceptor ueberspringt diesen Request,
    // sonst ersetzt die App den Gift-Add durch das komplette Bundle (Shaker!).
    fetch(theme.routes.cart_add_url + '?bundle_shark=true', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Gift add failed');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: { product: data.items ? data.items[0] : data }
          })
        );
      })
      .catch(function (error) {
        console.error('Error adding free gift brush:', error);
        button.classList.remove('loading');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-bogo-card--add');
    if (!button) return;
    event.preventDefault();
    addGiftBrush(button);
  });
})();
